module.exports = __webpack_public_path__ + "static/media/receive.dd834095.png";